import type { DashboardLayoutItem, DashboardWidgetType } from "../../lib/types";

export const DASHBOARD_WIDGET_ORDER: DashboardWidgetType[] = [
  "dimension-type-overview",
  "map-snapshot",
  "dimension-type-overview-strategy",
];

function cloneLayoutItem(item: DashboardLayoutItem): DashboardLayoutItem {
  return {
    ...item,
    settings: item.settings ? { ...item.settings } : undefined,
  };
}

export function createDefaultDashboardLayout(): DashboardLayoutItem[] {
  return DASHBOARD_WIDGET_ORDER.map((widgetType) => ({
    widgetType,
    visible: true,
  }));
}

export function normaliseDashboardLayout(
  layout?: DashboardLayoutItem[] | null,
): DashboardLayoutItem[] {
  if (!layout || layout.length === 0) {
    return createDefaultDashboardLayout();
  }

  const byType = new Map<DashboardWidgetType, DashboardLayoutItem>();

  for (const item of layout) {
    if (!DASHBOARD_WIDGET_ORDER.includes(item.widgetType)) {
      continue;
    }
    if (byType.has(item.widgetType)) {
      continue;
    }
    byType.set(item.widgetType, cloneLayoutItem(item));
  }

  return DASHBOARD_WIDGET_ORDER.map(
    (widgetType) => byType.get(widgetType) ?? { widgetType, visible: true },
  );
}
